import React from 'react';
import { Badge } from '../ui/Badge';
import { Play, Pause } from 'lucide-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function SingleVoiceLabelEditor({voice, isSelected, onSelect, audioControls}){

    return (
        <div className='tw:flex tw:items-center tw:justify-between tw:w-full tw:px-3 tw:py-2 single-voice-label'>
            <div className='tw:flex tw:items-center'>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 50, hide: 400 }}
                    overlay={SelectVoiceTooltip}
                >
                    {/**
                     * Sometimes after selecting a different voice, the old voice and the new voice both are checked.
                     * https://app.birdeatsbug.com/workspaces/86dce122-80ab-4549-979f-f562f287a65d/collections/a79b0569-9a54-4bb0-95fc-3de73e38b82e/sessions/MwBys4T19Z49VlX0JCD848kfrpHxa6RxnjAyaFr28kuE
                     * https://insights.hotjar.com/r?site=3015581&recording=17525427445&startTime=191000&token=1337fe45adb2008775a351076d10901b
                     * 
                     * BUG not reproducible
                     * Trying out explicit true false values for checked attribute to see if it will be fixed. 
                     * Issue can also be withing HotJar only. It is not able to reflect this change in recording but actually it worked fine.
                     */}
                    <input 
                        type='checkbox' 
                        checked={isSelected ? true : false} 
                        onChange={onSelect}
                        onClick={(e) => e.stopPropagation()}
                        className='tw:w-5 tw:h-5 tw:cursor-pointer'
                    />
                </OverlayTrigger>
                <span className='tw:mx-2 tw:flex'>{`${voice.name}(${voice.gender.charAt(0).toUpperCase()})`}</span>
                <VoiceBadges voice={voice} />
            </div>
            <div className='tw:flex tw:items-center tw:gap-2' onClick={(e) => e.stopPropagation()}>
                <PlayerIconButton audioControls={audioControls} voice={voice} />
            </div>
        </div>
    );
};

export const SelectVoiceTooltip = (props) => {
    return (
        <Tooltip id="button-tooltip" {...props}>
            Select voice
        </Tooltip>
    )
}

export const PlayerButtonTooltip = (props) => {
    return (
        <Tooltip id="button-tooltip" {...props}>
            Play
        </Tooltip>
    )
}

const PlayerIconButton = ({voice, audioControls}) => {

    const { audio, setAudio, isPlaying, setIsPlaying } = audioControls;
    const voiceSample = getAudioURL(voice.audio);

    return (
        <>
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 50, hide: 400 }}
                overlay={PlayerButtonTooltip}
            >
                {
                    (isPlaying && audio === voiceSample) 
                        ? <span className="play-icon" onClick={() => {
                            setIsPlaying(false)
                        }} >
                            <Pause size={18} />
                        </span>
                        : <span className="play-icon" onClick={() => {
                            setAudio(voiceSample)
                            setIsPlaying(true)
                        } } >
                            <Play size={18} />
                        </span>
                }
            </OverlayTrigger>
        </>
    )
}

const VoiceBadges = ({voice}) => {
    return (
        <div className='tw:flex tw:items-center tw:gap-1'>
            {
                (voice.engine === "neural") && <Badge variant="warning">Premium</Badge>
            }
            {
                (voice.engine === "emotional") && <Badge variant="gradient-violet">Emotional</Badge>
            }
            {
                (voice.styles && voice.styles.length) ? <Badge variant="primary">Styles</Badge> : null
            }
        </div>
    )
}

const getAudioURL = (audio) => {
    return `${process.env.REACT_APP_AUDIO_PREVIEW_URL}/${audio}`
}
